export default "/assets/images/hhr-access-screenshot.jpeg?2ebffa8594a858d64bd4084f802aec5e";